import './global.css';
import './variables.css';

import * as Sentry from '@sentry/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';

import { App } from './App';
import { queryClient } from './api/queries/client';
import { RootErrorBoundary } from './components/ErrorBoundaryFallback';
import { FullScreenSpinner } from './components/FullScreenSpinner';
import { env, isLocalDev, isProd, isProdOrStaging } from './env';
import { initI18nInstance } from './i18n';
import { Analytics } from './utils/analytics';
import { getAppDomain } from './utils/localize';

if (isProdOrStaging) {
  Analytics.initializeTagManager();
}

// route users to the correct locale domain based on their browser language if they landed on a legacy domain
const handleDomainRouting = () => {
  const domain = getAppDomain();

  if (!['fr', 'de', 'nl'].includes(domain)) {
    console.warn(`Invalid domain: ${domain} - redirecting to default domain`);
    const language = (navigator.languages && navigator.languages[0]) || navigator.language;
    const defaultDomain = language.startsWith('fr') ? 'fr' : language.startsWith('de') ? 'de' : 'nl';
    const currentUrl = new URL(window.location.href);
    const search = currentUrl.search;
    const pathname = currentUrl.pathname;
    const host = `${isProd ? '' : `${env}.`}my.insify.${defaultDomain}`;
    const newUrl = new URL(`https://${host}${pathname}${search}`);
    window.location.href = newUrl.toString();
    return;
  }
};

if (!isLocalDev) handleDomainRouting();

initI18nInstance();

ReactDOM.createRoot(document.getElementById('root')!).render(
  // <React.StrictMode>
  <Sentry.ErrorBoundary fallback={RootErrorBoundary}>
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={<FullScreenSpinner show />}>
        <App />
      </Suspense>
    </QueryClientProvider>
  </Sentry.ErrorBoundary>,
  // </React.StrictMode>,
);
